<template>
  <v-card>
    <v-card-title>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="peopleList"
      :search="search"
      group-by="groupLetter"
      disable-pagination
      hide-default-footer
      class="elevation-1">
      <template v-slot:group.header="{ group, items, headers, toggle }">
        <td @click="toggle" :colspan="headers.length">
          <strong>{{ group }}</strong> ({{ items.length }})
        </td>
      </template>
      <template v-slot:item.displayName="props">
        {{displayName(props.item.person)}}
      </template>
      <template v-slot:item.organization="props">
        <router-link :to="'/administration/organization/'+props.item.person.organization.id">{{props.item.person.organization.name}}</router-link>
      </template>
      <template v-slot:item.created="props">
        {{displayDate(props.item.person.created)}}
      </template>
      <template v-slot:item.modified="props">
        {{displayDate(props.item.person.modified)}}
      </template>
      <template v-slot:item.lastSignIn="props">
        {{displayDate(props.item.person.lastSignIn)}}
      </template>
      <template v-slot:item.isOrganizationAdmin="props">
        <v-icon :color="(props.item.person.isOrganizationAdmin ? 'success' : 'error')">{{getIcon(props.item.person.isOrganizationAdmin)}}</v-icon>
      </template>
      <template v-slot:item.isUserAdmin="props">
        <v-icon :color="(props.item.person.isUserAdmin ? 'success' : 'error')">{{getIcon(props.item.person.isUserAdmin)}}</v-icon>
      </template>
      <template v-slot:item.isEditor="props">
        <v-icon :color="(props.item.person.isEditor ? 'success' : 'error')">{{getIcon(props.item.person.isEditor)}}</v-icon>
      </template>
      <template v-slot:item.isValidator="props">
        <v-icon :color="(props.item.person.isValidator ? 'success' : 'error')">{{getIcon(props.item.person.isValidator)}}</v-icon>
      </template>
      <template v-slot:no-data>
        <p>No results</p>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
export default {
  props: ["me"],
  data: () => ({
    people: [],
    identityProfiles: [],
    baseUsers: [],
    headers: [],
    peopleList: [],
    expanded: [],
    sexes: [
      {value: 0, name:'Unknown' },
      {value: 1, name:'Male' },
      {value: 2, name:'Female' },
      {value: 3, name:'Unspecified' }
    ],
    search: ''
  }),
  methods: {
    statusIdToName(id, nl) {
      if (this.$root.$children[0]) {
        return this.$root.$children[0].getIdentityStatusName(id, nl);
      }
      else return "";
    },
    displayDate(date) {
      if (!date) return "-";
      return this.$moment(date).format("DD-MM-YYYY");
    },
    displayName(person) {
      var name = person.surname;
      if (person.surnamePrefix) name = name + ', ' + person.surnamePrefix;
      if (person.firstname) name = name + ', ' + person.firstname;
      if (person.initials) name = name + ' (' + person.initials + ')';
      return name;
    },
    getSex(person) {
      return this.sexes.find(x => x.value == person.sex).name
    },
    getIcon(val) {
      return val ? "mdi-check-bold" : "mdi-checkbox-blank-circle-outline"
    },
    updateList() {
      this.peopleList = [];
      if (this.people.length) {
        this.headers = [
          { text: 'Name', value: 'displayName' },
          { text: 'Organization', value: 'organization' },
          { text: 'E-mail', value: 'person.email' },
          { text: 'Created', value: 'created' },
          { text: 'Modified', value: 'modified' },
          { text: 'Last seen', value: 'lastSignIn' },
          { text: 'Org Admin', value: 'isOrganizationAdmin' },
          { text: 'User Admin', value: 'isUserAdmin' },
          { text: 'Editor', value: 'isEditor' },
          { text: 'Validator', value: 'isValidator' }
        ];
        this.people.forEach(p => {
          let newPerson = {
            groupLetter: p.surname ? p.surname.substring(0,1).toUpperCase() : '#',
            person: {
              id: p.id,
              firstname: p.firstname,
              surnamePrefix: p.surnamePrefix,
              surname: p.surname,
              initials: p.initials,
              birthdate: p.birthdate ? this.$moment.utc(p.birthdate).local().format("YYYY-MM-DD") : '',
              sex: p.sex,
              email: p.email,
              created: p.created ? this.$moment.utc(p.created).local().format("YYYY-MM-DD") : '',
              modified: p.modified ? this.$moment.utc(p.modified).local().format("YYYY-MM-DD") : '',
              lastSignIn: p.lastSignIn ? this.$moment.utc(p.lastSignIn).local().format("YYYY-MM-DD") : '',
              isUserAdmin: p.isUserAdmin,
              isOrganizationAdmin: p.isOrganizationAdmin,
              isEditor: p.isEditor,
              isValidator: p.isValidator,
              identityProfilePersons: p.identityProfilePersons,
              organization: p.organization
            }
          };
          this.peopleList.push(newPerson);
        });
      }
    },
    getPeople() {
      this.$http
        .get("api/person/")
        .then(request => {
          this.people = request.data;
          this.updateList();
        })
        .catch(e => {
          this.$root.$children[0].$emit("display-error", "2000", e);
        });
    },
    getIdentityProfiles() {
      this.$http
        .get("api/identityprofiles/active")
        .then(request => {
          this.identityProfiles = request.data;
        })
        .catch(e => {
          this.$root.$children[0].$emit("display-error", "2001", e);
        });
    }
  },
  mounted: function() {
    this.getIdentityProfiles();
    this.getPeople();
  }
};
</script>